import { z } from "zod";

export const GeoLogSchema = z.object({
  id: z.string().optional(),
  user_account_id: z.string(),
  emp_account_id: z.string(),
  lat: z.number(),
  long: z.number(),
  tracking_uuid: z.string().optional(), // Add tracking_uuid field
  created_at: z.date().optional(), // Optional field for created date/time
  expires_at: z.date().optional(), // Optional field for expiration date/time
  current_date_time: z.string().optional(), // Optional field for current date/time
});

export type GeoLog = z.infer<typeof GeoLogSchema>;
